import "./IconTurnDownLeftArrow.scss";
import { ReactComponent as TurnDownLeftArrowSVG } from "./svg/turn-down-left-arrow.svg";

type Props = {
  color?: "black" | "blue";
};

export const IconTurnDownLeftArrow = ({ color = "black" }: Props) => {
  return (
    <span className={`IconTurnDownLeftArrow IconTurnDownLeftArrow__${color}`}>
      <TurnDownLeftArrowSVG />
    </span>
  );
};
